import { render, staticRenderFns } from "./full-screen.vue?vue&type=template&id=703d5e01&scoped=true&"
import script from "./full-screen.vue?vue&type=script&lang=js&"
export * from "./full-screen.vue?vue&type=script&lang=js&"
import style0 from "./full-screen.vue?vue&type=style&index=0&id=703d5e01&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703d5e01",
  null
  
)

export default component.exports